export const ADD_NEW_CAMPAIGN = 'ADD_NEW_CAMPAIGN';

export const DELETE_JOURNEY_CAMPAIGN = 'DELETE_CAMPAIGN';

export const UPDATE_JOURNEY_CONTENT = 'UPDATE_JOURNEY_CONTENT';
export const UPDATE_JOURNEY_SEGMENT = 'UPDATE_JOURNEY_SEGMENT';
export const UPDATE_JOURNEY_SCHEDULE = 'UPDATE_JOURNEY_SCHEDULE';
export const UPDATE_JOURNEY_CHANNEL = 'UPDATE_JOURNEY_CHANNEL';

export const RESET_JOURNEY_DETAILS = 'RESET_JOURNEY_DETAILS';

export const UPDATE_MULTI_CAMPAIGN_DETAILS = 'UPDATE_MULTI_CAMPAIGN_DETAILS';

export const SUBMIT_MULTI_CAMPAIGN_FORM = 'SUBMIT_MULTI_CAMPAIGN_FORM';

export const UPDATE_FORM_VIEW = 'UPDATE_FORM_VIEW';

export const UPDATE_MULTI_CAMPAIGN_RESPONSE = 'UPDATE_MULTI_CAMPAIGN_RESPONSE';
